function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styles from './AccordionLayoutItem.module.scss';
import cs from 'classnames';
import AccordionItem from '../../Accordion/AccordionItem/AccordionItem';
import H from '../../H/H';
import Icon from '../../Icons/Icon/Icon';
import { ReactComponent as Arrow } from '../../../icons/DirectionalArrow/DirectionalArrow.svg';
import ListItem from '../ListItem';
var ARROW_DIMENSION = 14;
function Header(_ref) {
  var id = _ref.id,
    open = _ref.open,
    name = _ref.name,
    props = _objectWithoutProperties(_ref, ["id", "open", "name"]);
  return /*#__PURE__*/React.createElement(H, {
    id: id,
    className: styles.heading
  }, /*#__PURE__*/React.createElement("button", props, /*#__PURE__*/React.createElement(Icon, {
    height: ARROW_DIMENSION,
    width: ARROW_DIMENSION,
    className: cs(styles.icon, styles[open ? 'open' : 'closed'])
  }, /*#__PURE__*/React.createElement(Arrow, {
    height: ARROW_DIMENSION,
    width: ARROW_DIMENSION
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.text,
    dangerouslySetInnerHTML: {
      __html: name
    }
  })));
}
export default function AccordionLayoutItem(_ref2) {
  var id = _ref2.id,
    name = _ref2.name,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(ListItem, {
    className: cs(styles.item, 'component-set')
  }, /*#__PURE__*/React.createElement(AccordionItem, {
    labelledby: id,
    title: name,
    defaultOpen: true,
    button: function button(_ref3) {
      var buttonProps = _ref3.buttonProps,
        checked = _ref3.checked;
      return /*#__PURE__*/React.createElement(Header, Object.assign({}, buttonProps, {
        id: id,
        name: name,
        open: checked
      }));
    }
  }, children));
}